<template>
    <div class="website-config-container">
        <el-form ref="websiteForm" :model="websiteForm" label-width="120px" class="website-form">
            <!-- 站点端配置 -->
            <el-card class="config-card">
                <template #header>
                    <div class="card-header">
                        <span class="card-title">站点端配置</span>
                    </div>
                </template>

                <el-form-item label="站点店铺名称">
                    <el-input v-model="websiteForm.site_shop_name" placeholder="请输入站点端店铺名称" />
                </el-form-item>

                <el-form-item label="站点店铺Logo">
                    <div class="upload-section">
                        <el-upload class="upload-demo" :auto-upload="false" :show-file-list="false"
                            :on-change="handleSiteLogoChange" accept="image/*">
                            <el-button type="primary">选择图片</el-button>
                        </el-upload>
                        <div v-if="websiteForm.site_shop_logo" class="upload-preview">
                            <el-image :src="websiteForm.site_shop_logo" class="preview-image" fit="contain" />
                            <div class="preview-url">{{ websiteForm.site_shop_logo }}</div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="站点Favicon">
                    <div class="upload-section">
                        <el-upload class="upload-demo" :auto-upload="false" :show-file-list="false"
                            :on-change="handleSiteFaviconChange" accept="image/*">
                            <el-button type="primary">选择图片</el-button>
                        </el-upload>
                        <div v-if="websiteForm.site_h5_favicon" class="upload-preview">
                            <el-image :src="websiteForm.site_h5_favicon" class="preview-image" fit="contain" />
                            <div class="preview-url">{{ websiteForm.site_h5_favicon }}</div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="站点版权配置">
                    <div class="copyright-config">
                        <div v-for="(item, index) in websiteForm.site_copyright" :key="index" class="copyright-item">
                            <el-input v-model="item.key" placeholder="显示文本" style="width: 200px; margin-right: 10px" />
                            <el-input v-model="item.value" placeholder="链接地址（可选）" style="width: 300px; margin-right: 10px" />
                            <el-button type="danger" size="small" @click="removeSiteCopyright(index)">删除</el-button>
                        </div>
                        <el-button type="primary" size="small" @click="addSiteCopyright">添加版权项</el-button>
                    </div>
                </el-form-item>
            </el-card>

            <!-- 商户端配置 -->
            <el-card class="config-card">
                <template #header>
                    <div class="card-header">
                        <span class="card-title">商户端配置</span>
                    </div>
                </template>

                <el-form-item label="商户端域名">
                    <el-input v-model="storeDomain" disabled placeholder="自动生成" />
                    <div class="help-text">商户端访问地址：{{ storeDomain }}/store</div>
                </el-form-item>

                <el-form-item label="商户端标题">
                    <el-input v-model="websiteForm.store_pc_title" placeholder="请输入商户端PC标题" />
                </el-form-item>

                <el-form-item label="商户端Logo">
                    <div class="upload-section">
                        <el-upload class="upload-demo" :auto-upload="false" :show-file-list="false"
                            :on-change="handleStoreLogoChange" accept="image/*">
                            <el-button type="primary">选择图片</el-button>
                        </el-upload>
                        <div v-if="websiteForm.store_pc_logo" class="upload-preview">
                            <el-image :src="websiteForm.store_pc_logo" class="preview-image" fit="contain" />
                            <div class="preview-url">{{ websiteForm.store_pc_logo }}</div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="商户端Favicon">
                    <div class="upload-section">
                        <el-upload class="upload-demo" :auto-upload="false" :show-file-list="false"
                            :on-change="handleStoreFaviconChange" accept="image/*">
                            <el-button type="primary">选择图片</el-button>
                        </el-upload>
                        <div v-if="websiteForm.store_pc_ico" class="upload-preview">
                            <el-image :src="websiteForm.store_pc_ico" class="preview-image" fit="contain" />
                            <div class="preview-url">{{ websiteForm.store_pc_ico }}</div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="商户端版权配置">
                    <div class="copyright-config">
                        <div v-for="(item, index) in websiteForm.store_copyright" :key="index" class="copyright-item">
                            <el-input v-model="item.key" placeholder="显示文本" style="width: 200px; margin-right: 10px" />
                            <el-input v-model="item.value" placeholder="链接地址（可选）" style="width: 300px; margin-right: 10px" />
                            <el-button type="danger" size="small" @click="removeStoreCopyright(index)">删除</el-button>
                        </div>
                        <el-button type="primary" size="small" @click="addStoreCopyright">添加版权项</el-button>
                    </div>
                </el-form-item>
            </el-card>

            <div class="form-actions">
                <el-button type="primary" @click="submitWebsiteConfig" :loading="submitting">保存配置</el-button>
                <el-button @click="resetForm">重置</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import Cookies from 'js-cookie'
import { getUploadSignature, uploadToOSS } from '@/utils/uploadUtils'

export default {
    name: 'WebsiteConfig',
    data() {
        return {
            websiteForm: {
                site_shop_name: '',
                site_shop_logo: '',
                site_h5_favicon: '',
                site_copyright: [],
                store_pc_title: '',
                store_pc_logo: '',
                store_pc_ico: '',
                store_copyright: [],
                store_domain: ''
            },
            submitting: false,
            currentUploadType: '' // 当前上传类型
        }
    },
    computed: {
        userInfo() {
            return JSON.parse(Cookies.get('user_info') || '{}')
        },
        storeDomain() {
            if (this.websiteForm.store_domain) {
                return this.websiteForm.store_domain
            }
            return `${window.location.host}/store`
        }
    },
    mounted() {
        this.fetchWebsiteConfig()
    },
    methods: {
        // 获取网站配置
        async fetchWebsiteConfig() {
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    {
                        action: 'get_website_config',
                        store_id: this.userInfo.id
                    }
                )

                if (data.success && data.data) {
                    this.websiteForm = {
                        ...data.data,
                        site_copyright: data.data.site_copyright || [],
                        store_copyright: data.data.store_copyright || []
                    }
                }
            } catch (error) {
                this.$message.error('获取网站配置失败')
                console.error('获取网站配置错误:', error)
            }
        },

        // 处理图片上传
        async handleImageChange(file, type) {
            try {
                this.$message.info('图片上传中，请稍候...')
                const url = await this.uploadImage(file.raw)
                this.websiteForm[type] = url
                this.$message.success('图片上传成功')
            } catch (error) {
                this.$message.error(`图片上传失败: ${error.message}`)
                console.error('上传错误:', error)
            }
        },

        // 站点Logo上传
        handleSiteLogoChange(file) {
            this.handleImageChange(file, 'site_shop_logo')
        },

        // 站点Favicon上传
        handleSiteFaviconChange(file) {
            this.handleImageChange(file, 'site_h5_favicon')
        },

        // 商户端Logo上传
        handleStoreLogoChange(file) {
            this.handleImageChange(file, 'store_pc_logo')
        },

        // 商户端Favicon上传
        handleStoreFaviconChange(file) {
            this.handleImageChange(file, 'store_pc_ico')
        },

        // 上传图片
        async uploadImage(file) {
            try {
                const loading = this.$loading({
                    lock: true,
                    text: '图片上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })

                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/x-icon']
                const maxSize = 2 * 1024 * 1024

                if (allowedTypes.indexOf(file.type) === -1) {
                    throw new Error(`不支持的文件类型: ${file.type}，仅支持 ${allowedTypes.join(', ')}`)
                }

                if (file.size > maxSize) {
                    throw new Error(`文件大小超过限制 (2MB): ${(file.size / 1024 / 1024).toFixed(2)}MB`)
                }

                const signature = await getUploadSignature(file.type.split('/')[0])
                const res = await uploadToOSS(file, signature)

                loading.close()
                return res.url
            } catch (error) {
                this.$loading().close()
                console.error('图片上传失败:', error)
                throw error
            }
        },

        // 版权配置操作
        addSiteCopyright() {
            this.websiteForm.site_copyright.push({ key: '', value: '' })
        },

        removeSiteCopyright(index) {
            this.websiteForm.site_copyright.splice(index, 1)
        },

        addStoreCopyright() {
            this.websiteForm.store_copyright.push({ key: '', value: '' })
        },

        removeStoreCopyright(index) {
            this.websiteForm.store_copyright.splice(index, 1)
        },

        // 提交网站配置
        async submitWebsiteConfig() {
            this.submitting = true
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    {
                        action: 'update_website_config',
                        store_id: this.userInfo.id,
                        ...this.websiteForm
                    }
                )

                if (data.success) {
                    this.$message.success('网站配置更新成功')
                } else {
                    this.$message.error(data.error || '更新失败')
                }
            } catch (error) {
                const errorMsg = error.response?.data?.error || error.message || '更新失败'
                this.$message.error(`更新失败: ${errorMsg}`)
                console.error('网站配置更新错误:', error)
            } finally {
                this.submitting = false
            }
        },

        // 重置表单
        resetForm() {
            this.fetchWebsiteConfig()
        }
    }
}
</script>

<style scoped lang="scss">
.website-config-container {
    padding: 0px;
}

.config-card {
    margin-bottom: 24px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 112, 72, 0.3);

    :deep(.el-card__header) {
        background: rgba(255, 112, 72, 0.1);
        border-bottom: 1px solid rgba(255, 112, 72, 0.2);
    }

    .card-header {
        .card-title {
            color: #ff7048;
            font-weight: 600;
            font-size: 16px;
        }
    }
}

.upload-section {
    .upload-preview {
        margin-top: 10px;
        padding: 10px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;

        .preview-image {
            max-width: 100px;
            max-height: 100px;
            display: block;
            margin-bottom: 8px;
        }

        .preview-url {
            word-break: break-all;
            font-size: 12px;
            color: #e0e6ff;
        }
    }
}

.copyright-config {
    .copyright-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding: 10px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }
}

.help-text {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
}

.form-actions {
    margin-top: 24px;
    text-align: center;
}

:deep(.el-form-item__label) {
    color: #e0e6ff !important;
}

:deep(.el-input__inner) {
    color: #ffffff !important;
    border: 1px solid rgba(255, 112, 72, 0.3) !important;
}

:deep(.el-input__inner::placeholder) {
    color: rgba(255, 255, 255, 0.5) !important;
}
</style>